export default [
  {
    path: '/set-part-used',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'SetPartUsed',
        component: () => import('./containers/SetPartUsedContainer'),
      },
    ],
  },
]
